/* eslint-disable */
/**
 * @module mlclib/unitconverter
 * @description
 * Part of MLC utilities javascript library functions.
 * Provides unit conversion facilities.
 * @example let unitConverter = require('path/to/folder/of/mlclib').utils.unitConverter;
 */

export const unitConverter = (function() {
  /**
   * @description
   *
   * lookup a type for a unit
   * @param {string} unit The unit identifier.
   * @returns {type:string} as 'number', 'string' 'datetime' or 'undefined'
   * on error console error output
   */
  function lookupType(unit) {
    switch (unit) {
      // numeric units:
      case "UM":
      case "CMM":
      case "MM":
      case "CM":
      case "M":
      case "KM":
      case "PICKS":
      case "KILOPICKS":
      case "REPEATS":
      case "RPM":
      case "RPMROUND10":
      case "LABELS":
      case "HOURS":
      case "HOURSMINUTES":
      case "MINUTES":
      case "SECONDS":
      case "PERCENT":
      case "PERMILL":
      case "PPM":
      case "PICKSPERCM":
      case "PICKSPERM":
      case "PICKSPER100M":
      case "INCREMENTS":
      case "CENTIDEGREES":
      case "DEGREES":
      case "DEGREECELSIUS":
      case "BYTES":
      case "KILOBYTES":
      case "MEGABYTES":
      case "GIGABYTES":
      case "DAYOFWEEKNUM":
      case "WEEK":
      case "GRAM":
      case "MA":
      case "A":
      case "THREAD":
      case "MILLIVOLT":
      case "IPV4ADDRESS":
      case "IPV4NETMASK":
      case "IPV4GATEWAY": {
        return "number";
      }
      case "DATETIME": {
        return "datetime";
      }

      // string units:
      case "SHIFT":
      case "LOGTEXT":
      case "FILENAME":
      case "HOSTNAME":
      case "ORDERNAME":
      case "DAYOFWEEKTEXT": // engl. abbreviated text: Mo Tu We Th Fr Sa Su
      case "PASSWORD":
      case "ISODATETIMESTRING": {
        // ISO: 'YYYY-MM-DD HH:MM:SS'
        return "string";
      }
      case "":
        return "";
      default: {
        console.error("mlc.lookupType: unknown unit " + unit);
        return "unknown";
      }
    }
  }

  /**
   * @description
   *
   * for text units, get max number of characters
   * on error (unknown type) alert is shown
   */
  function getMaxLength(unit) {
    switch (unit) {
      // numeric units:
      case "UM":
      case "CMM":
      case "MM":
      case "CM":
      case "M":
      case "KM":
      case "PICKS":
      case "KILOPICKS":
      case "REPEATS":
      case "RPM":
      case "RPMROUND10":
      case "LABELS":
      case "HOURS":
      case "HOURSMINUTES":
      case "MINUTES":
      case "SECONDS":
      case "PERCENT":
      case "PERMILL":
      case "PPM":
      case "PICKSPERCM":
      case "PICKSPERM":
      case "PICKSPER100M":
      case "INCREMENTS":
      case "DEGREES":
      case "CENTIDEGREES":
      case "BYTES":
      case "KILOBYTES":
      case "MEGABYTES":
      case "GIGABYTES":
      case "DAYOFWEEKNUM":
      case "WEEK":
      case "GRAM":
      case "THREAD":
      case "MILLIVOLT":
      case "MA": {
        return 0;
      }
      case "A": {
        return 0;
      }
      case "DATETIME": {
        return 0; // unused, not Text
      }

      // string units:
      case "SHIFT": {
        return 1;
      }
      case "LOGTEXT": {
        return 80;
      }
      case "FILENAME":
      case "ORDERNAME": // not used,yet, ---> FILENAME
      case "ARTICLENAME": {
        // not used,yet, ---> FILENAME
        return 20; // may be we allow more... ???
      }
      case "IPV4ADDRESS":
      case "IPV4NETMASK":
      case "IPV4GATEWAY": {
        return 15; // xxx.xxx.xxx.xxx
      }
      case "HOSTNAME": {
        return 20; //  arbitrarily, may be we allow more... ???
      }
      case "DAYOFWEEKTEXT": {
        // engl. abbreviated text: Mo Tu We Th Fr Sa Su
        return 2;
      }
      case "PASSWORD": {
        return 20; // arbitrarily, may be more ???
      }

      case "ISODATETIMESTRING": {
        // ISO: 'YYYY-MM-DD HH:MM:SS'
        return 19;
      }
      case "":
        return 0;
      default: {
        console.error("mlc.getMaxLength: unknown unit " + unit);
        return "unknown";
      }
    }
  }

  /**
   * @description
   *
   * lookup a label text for a unit
   * actual: english label text,                       TODO: later: language dependent
   * @param {string} unit The unit identifier.
   * @returns {label:string} as text
   * on error (unknown type) alert is shown
   */
  function lookupUnitLabel(unit, extended) {
    switch (unit) {
      // numeric units:
      case "UM":
        if (extended) {
          return "1/1000 Millimeter";
        }
        return "um";
      case "CMM":
        if (extended) {
          return "1/100 Millimeter";
        }
        return "cmm";
      case "MM":
        if (extended) {
          return "Millimeter";
        }
        return "mm";
      case "CM":
        if (extended) {
          return "Centimeter";
        }
        return "cm";
      case "M":
        if (extended) {
          return "Meter";
        }
        return "m";
      case "KM":
        if (extended) {
          return "Kilometer";
        }
        return "km";
      case "PICKS":
        return "Picks";
      case "KILOPICKS":
        if (extended) {
          return "Kilopicks";
        }
        return "kPicks";
      case "REPEATS":
        if (extended) {
          return "Repeats";
        }
        return "r";
      case "RPM":
      case "RPMROUND10":
        if (extended) {
          return "Rounds per Minute";
        }
        return "RPM";
      case "LABELS":
        return "Labels";
      case "HOURS":
        if (extended) {
          return "Hours";
        }
      // fall through
      case "HOURSMINUTES":
        if (extended) {
          return "Hours:Minutes";
        }
        return "h";
      case "MINUTES":
        if (extended) {
          return "Minutes";
        }
        return "'";
      case "SECONDS":
        if (extended) {
          return "Seconds";
        }
        return "''";
      case "PERCENT":
        if (extended) {
          return "Percent";
        }
        return "%";
      case "PERMILL":
        if (extended) {
          return "Permille";
        }
        return "0/00";
      case "PPM":
        if (extended) {
          return "Parts Per Million";
        }
        return "PPM";
      case "PICKSPERCM":
        if (extended) {
          return "Picks per Centimeter";
        }
        return "Picks/cm";
      case "PICKSPERM":
        if (extended) {
          return "Picks per Meter";
        }
        return "Picks/m";
      case "PICKSPER100M":
        if (extended) {
          return "Picks per 100 Meter";
        }
        return "Picks/100m";
      case "DEGREES":
        if (extended) {
          return "Degrees";
        }
        return "�";
      case "CENTIDEGREES":
        if (extended) {
          return "1/100 Degrees";
        }
        return "1�/100";
      case "DEGREECELSIUS":
        if (extended) {
          return "Degrees Celsius";
        }
        return "�C";
      case "BYTES":
        return "Bytes";
      case "KILOBYTES":
        if (extended) {
          return "Kilobytes";
        }
        return "kB";
      case "MEGABYTES":
        if (extended) {
          return "Megabytes";
        }
        return "MB";
      case "GIGABYTES":
        if (extended) {
          return "Gigabytes";
        }
        return "GB";
      case "GRAM":
        if (extended) {
          return "Gram";
        }
        return "g";
      case "THREAD":
        return "Threads";
      case "MILLIVOLT":
        if (extended) {
          return "Millivolts";
        }
        return "mV";
      case "MA":
        if (extended) {
          return "Milliamperes";
        }
        return "mA";
      case "A": // Ampere
        if (extended) {
          return "Amperes";
        }
        return "A";

      case "INCREMENTS":
      case "DATETIME":
      case "WEEK":

      // String units;
      case "DAYOFWEEKNUM":
      case "SHIFT":
      case "LOGTEXT":
      case "FILENAME":
      case "IPV4ADDRESS":
      case "IPV4NETMASK":
      case "IPV4GATEWAY":
      case "HOSTNAME":
      case "ORDERNAME":
      case "DAYOFWEEKTEXT":
      case "PASSWORD":
      case "ISODATETIMESTRING": // ISO: 'YYYY-MM-DD HH:MM:SS'
      case "":
        return "";
      default:
        console.error("mlc.lookupUnitLabel: unknown unit " + unit);
        return "";
    }
  }

  // scale a value from one unit to another
  /**
   * @description
   *
   * scale a value from one unit to another
   * @param {string} valSrc The value to convert.
   * @param {string} unitSrc The unit of the param valSrc
   * @param {string} unitDst The requested unit for the return value
   * @returns {value:number} resulting value number
   * on error (unknown type) the function return the unchanged input value
   */
  function convertValue(valSrc, unitSrc, unitDst) {
    if (unitSrc == undefined || unitDst == undefined) {
      return valSrc;
    }

    if (unitSrc == unitDst) {
      return valSrc;
    }

    let factor = 1;
    let result = valSrc;
    let s = "";
    // either the factor is calculated in the case statement
    // or factor stays 1 and final result is calculated (e.g. at hour:minute formatting...)
    switch (unitSrc) {
      case "DEGREES":
        {
          switch (unitDst) {
            case "CENTIDEGREES": {
              factor = 100;
              break;
            }
            default:
              break;
          }
        }
        break;
      case "CENTIDEGREES":
        {
          switch (unitDst) {
            case "DEGREES": {
              factor = 0.01;
              break;
            }
            default:
              break;
          }
        }
        break;
      case "RPM":
        {
          switch (unitDst) {
            case "RPMROUND10": {
              result = (valSrc / 10).toFixed(0) * 10;
              break;
            }
            default:
              break;
          }
        }
        break;
      case "PERCENT":
        {
          switch (unitDst) {
            case "PERMILL": {
              factor = 10;
              break;
            }
            case "PPM": {
              factor = 10000;
              break;
            }
            default:
              break;
          }
        }
        break;
      case "PERMILL":
        {
          switch (unitDst) {
            case "PERCENT": {
              factor = 0.1;
              break;
            }
            case "PPM": {
              factor = 1000;
              break;
            }
            default:
              break;
          }
        }
        break;
      case "PPM":
        {
          switch (unitDst) {
            case "PERCENT": {
              factor = 0.00001;
              break;
            }
            case "PERMILL": {
              factor = 0.0001;
              break;
            }
            default:
              break;
          }
        }
        break;
      case "PICKSPERCM":
        {
          switch (unitDst) {
            case "PICKSPER100M": {
              factor = 10000;
              break;
            }
            case "PICKSPERM": {
              factor = 100;
              break;
            }
            default:
              break;
          }
        }
        break;
      case "PICKSPERM":
        {
          switch (unitDst) {
            case "PICKSPERCM": {
              factor = 0.01;
              break;
            }
            case "PICKSPER100M": {
              factor = 100;
              break;
            }
            default:
              break;
          }
        }
        break;
      case "PICKSPER100M":
        {
          switch (unitDst) {
            case "PICKSPERCM": {
              factor = 0.0001;
              break;
            }
            case "PICKSPERM": {
              factor = 0.01;
              break;
            }
            default:
              break;
          }
        }
        break;
      case "CMM":
        {
          switch (unitDst) {
            case "MM": {
              factor = 0.01;
              break;
            }
            case "CM": {
              factor = 0.001;
              break;
            }
            case "M": {
              factor = 0.00001;
              break;
            }
            case "KM": {
              factor = 0.00000001;
              break;
            }
            default:
              break;
          }
        }
        break;
      case "UM":
        {
          switch (unitDst) {
            case "MM": {
              factor = 0.001;
              break;
            }
            case "CM": {
              factor = 0.0001;
              break;
            }
            case "M": {
              factor = 0.000001;
              break;
            }
            case "KM": {
              factor = 0.000000001;
              break;
            }
            default:
              break;
          }
        }
        break;
      case "MM":
        {
          switch (unitDst) {
            case "UM": {
              factor = 1000;
              break;
            }
            case "CMM": {
              factor = 100;
              break;
            }
            case "CM": {
              factor = 0.1;
              break;
            }
            case "M": {
              factor = 0.001;
              break;
            }
            case "KM": {
              factor = 0.000001;
              break;
            }
            default:
              break;
          }
        }
        break;
      case "CM":
        {
          switch (unitDst) {
            case "UM": {
              factor = 10000;
              break;
            }
            case "CMM": {
              factor = 1000;
              break;
            }
            case "MM": {
              factor = 10;
              break;
            }
            case "M": {
              factor = 0.01;
              break;
            }
            case "KM": {
              factor = 0.00001;
              break;
            }
            default:
              break;
          }
        }
        break;
      case "KM":
        {
          switch (unitDst) {
            case "UM": {
              factor = 1000000000;
              break;
            }
            case "CMM": {
              factor = 100000000;
              break;
            }
            case "MM": {
              factor = 1000000;
              break;
            }
            case "CM": {
              factor = 100000;
              break;
            }
            case "M": {
              factor = 1000;
              break;
            }
            default:
              break;
          }
        }
        break;
      case "A":
        {
          switch (unitDst) {
            case "MA": {
              factor = 1000;
              break;
            }
          }
        }
        break;
      case "MA":
        {
          switch (unitDst) {
            case "A": {
              factor = 0.001;
              break;
            }
          }
        }
        break;
      case "HOURS":
        {
          switch (unitDst) {
            case "HOURSMINUTES": {
              result = String(Math.floor(valSrc)) + ":";
              s = "0" + String((valSrc / 60).toFixed(0) % 60);
              result += s.substring(s.length - 2);
              break;
            }
            case "MINUTES": {
              factor = 60;
              break;
            }
            case "SECONDS": {
              factor = 3600;
              break;
            }
            default:
              break;
          }
        }
        break;
      case "MINUTES":
        {
          switch (unitDst) {
            case "HOURSMINUTES": {
              result = String(Math.floor(valSrc / 60)) + ":";
              s = "0" + String(valSrc % 60);
              result += s.substring(s.length - 2);
              break;
            }
            case "HOURS": {
              factor = 0.016666;
              break;
            }
            case "SECONDS": {
              factor = 60;
              break;
            }
            default:
              break;
          }
        }
        break;
      case "SECONDS":
        {
          switch (unitDst) {
            case "HOURSMINUTES": {
              result = String(Math.floor(valSrc / 3600)) + ":";
              s = "0" + String((valSrc / 60).toFixed(0) % 60);
              result += s.substring(s.length - 2);
              break;
            }
            case "HOURS": {
              factor = 0.00027778;
              break;
            }
            case "MINUTES": {
              factor = 0.016666;
              break;
            }
            default:
              break;
          }
        }
        break;
      case "PICKS":
        {
          switch (unitDst) {
            case "KILOPICKS": {
              factor = 0.001;
              break;
            }
          }
        }
        break;

      case "KILOPICKS":
        {
          switch (unitDst) {
            case "PICKS": {
              factor = 1000;
              break;
            }
          }
        }
        break;

      case "DATETIME":
        {
          switch (unitDst) {
            case "ISODATETIMESTRING": {
              result = "";
              if (valSrc.year != null && valSrc.year.val != null) {
                result = result + String(valSrc.year.val);
              }
              if (valSrc.month != null && valSrc.month.val != null) {
                if (result != "") {
                  result = result + "-";
                }
                if (valSrc.month.val < 10) {
                  result = result + "0";
                }
                result = result + String(valSrc.month.val);
              }
              if (valSrc.day != null && valSrc.day.val != null) {
                if (result != "") {
                  result = result + "-";
                }
                if (valSrc.day.val < 10) {
                  result = result + "0";
                }
                result = result + String(valSrc.day.val);
              }
              if (valSrc.hour != null && valSrc.hour.val != null) {
                if (result != "") {
                  result = result + " ";
                }
                result = result + String(valSrc.hour.val);
              }
              if (valSrc.minute != null && valSrc.minute.val != null) {
                if (result != "") {
                  result = result + ":";
                }
                if (valSrc.minute.val < 10) {
                  result = result + "0";
                }
                result = result + String(valSrc.minute.val);
              }
              if (valSrc.second != null && valSrc.second.val != null) {
                if (result != "") {
                  result = result + ":";
                }
                if (valSrc.second.val < 10) {
                  result = result + "0";
                }
                result = result + String(valSrc.second.val);
              }
              break;
            }
          }
        }
        break;

      case "MILLIDEGREECELSIUS":
        {
          switch (unitDst) {
            case "DEGREECELSIUS": {
              factor = 1 / 1000;
              break;
            }
            default: {
              break;
            }
          }
        }
        break;

      default:
        break;
    }
    if (factor != 1) {
      result = valSrc * factor;
    }
    return result;
  }

  // ==================================================================================
  // all known rules applied...
  function isValidIPV4Address(str) {
    let ipformat = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
    if (str.match(ipformat)) {
      let sp = str.split(".");
      if (Number(sp[0]) >= 224) return false; // class D = multicast adresses
      if (Number(sp[0]) == 127) return false; // reserved for loopback
      if (Number(sp[0]) == 255 && Number(sp[1]) == 255) return false; // 255.255.xx.xx = all networks
      if (Number(sp[2]) == 0 && Number(sp[3]) == 0) return false; // xx.xx.0.0  // all hosts
      if (Number(sp[2]) == 255 && Number(sp[3]) == 255) return false; // xx.xx.255.255  // broadcast
      if (Number(sp[0]) == 0 && Number(sp[1]) == 0) return false; // 0.0.xx.xx
      return true;
    }
    return false;
  }

  // ==================================================================================
  // we allow netmasks between 255.255.250.0 and 255.255.255.0
  function isValidIPV4Netmask(str) {
    let ipformat = /^255\.255\.(25[0-5]?)\.0$/;
    if (str.match(ipformat)) return true;
    return false;
  }

  // ==================================================================================
  // valid ipv4 and zero address allowed
  function isValidIPV4Gateway(str) {
    if (isValidIPV4Address(str)) {
      return true;
    }
    let sp = str.split(".");
    if (
      Number(sp[0]) == 0 &&
      Number(sp[1]) == 0 && // 'zero address allowed ---> undefined)
      Number(sp[2]) == 0 &&
      Number(sp[3]) == 0
    )
      return true; // 'zero address allowed ---> undefined)
    return false;
  }

  /**
   * The Interface Definition
   */
  let unitConverter = {
    lookupType: lookupType,
    lookupUnitLabel: lookupUnitLabel,
    convertValue: convertValue,
    getMaxLength: getMaxLength,
    isValidIPV4Address: isValidIPV4Address,
    isValidIPV4Netmask: isValidIPV4Netmask,
    isValidIPV4Gateway: isValidIPV4Gateway
  };

  return unitConverter;
})();
